import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="matrix"
export default class extends Controller {
  static targets = ['column', 'nr']

  initialize() {
    this.index = 1
    window.addEventListener('resize', this.changeMatrixVisibility, { passive: true })
  }

  changeMatrixVisibility = () => {
    if (window.innerWidth > 900) {
      this.columnTargets.forEach((element, index) => {
        element.style.visibility = 'visible'
      })
    } else {
      this.columnTargets.forEach((element, index) => {
        if (this.index == (index+1)) {
          element.style.visibility = 'visible'
        } else {
          element.style.visibility = 'hidden'
        }
      })
    }
  }

  disconnect () {
    window.removeEventListener('resize', this.changeMatrixVisibility, { passive: true })
  }

  next() {
    this.index++
    if (this.index >= 5) {
      this.index = 1;
    }
    
    this.nrTarget.innerHTML = this.index
    this.showCurrentColumn()
  }

  previous() {
    this.index--
    if (this.index <= 0) {
      this.index = 4;
    }
    this.nrTarget.innerHTML = this.index
    this.showCurrentColumn()
  }

  showCurrentColumn() {
    this.columnTargets.forEach((element, index) => {
      if ((index+1) == this.index) {
        element.style.visibility = 'visible'
      } else {
        element.style.visibility = 'hidden'
      }
    })
  }
}
